import {IRangeType} from "../types/IRangeType";

const getValidLower = (lower: IRangeType["lower"], min: number) => Math.max(lower || min, min);
const getValidUpper = (upper: IRangeType["upper"], max: number) => Math.min(upper || max, max);

/**
 * Checks if a value is within the given range bounds.
 *
 * @param value - The range to check against
 * @param filterOptionValue - The value to check if it's in range
 * @param filterOptionValueMin - Minimum possible value
 * @param filterOptionValueMax - Maximum possible value
 * @param threshold - Optional threshold for range checking (default: 0)
 * @returns true if the value is within range
 */
export const isValueInRange = (value: IRangeType, filterOptionValue: number, filterOptionValueMin: number, filterOptionValueMax: number, threshold = 0) => {
    const {lower, upper} = value;
    if (!lower && !upper) {
        return false;
    }
    const validLower = getValidLower(lower, filterOptionValueMin);
    const validUpper = getValidUpper(upper, filterOptionValueMax);
    return validLower - threshold <= filterOptionValue && filterOptionValue <= validUpper + threshold;
};
